import { apiGet } from "@/lib/http/client";
import type { CustomerListResponse } from "@/types/api";

export interface ListCustomersParams {
  email?: string;
  after_customer_id?: string;
  limit?: number;
}

export async function listCustomers(params: ListCustomersParams = {}) {
  return apiGet<CustomerListResponse>("/customers", {
    limit: params.limit ?? 100,
    email: params.email,
    after_customer_id: params.after_customer_id,
  });
}

const MAX_CUSTOMERS = 2000;

/** Paginate through Stripe customers until exhausted or cap. */
export async function listAllCustomers(params: { email?: string } = {}) {
  const items: CustomerListResponse["items"] = [];
  let after: string | undefined;
  while (items.length < MAX_CUSTOMERS) {
    const page = await listCustomers({
      limit: 100,
      email: params.email,
      after_customer_id: after,
    });
    items.push(...page.items);
    if (!page.has_more || !page.next_cursor) {
      break;
    }
    after = page.next_cursor;
  }
  return {
    items,
    has_more: false,
    next_cursor: null as string | null,
  };
}
